export { default } from "./SpaceComponentIcon";
